import { Controller } from '@hotwired/stimulus'

import { Events } from '../constants';

import { clearAll, sendEvent } from '../utils'

import { router, Routes } from '../router';

export default class extends Controller {

    static targets = [
    ]

    static values = {
    }

    initialize = () => {
    }

    connect = () => {
    }

    disconnect = () => {
    }

    cancel = () => {

        router.navigate(Routes[1].url, {
            historyAPIMethod: 'replaceState'
        })
    }

    confirm = () => {

        clearAll()
            .then(() => {

                sendEvent(Events.SHOW_LOGIN, { message: '' })

            }).catch(() => {})
    }
}
